import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { PROJECTS } from '../data/projects';
import '../styles/latest-work-grid.scss';

const LatestWorkGrid = ({ heading = 'Latest Work' }) => {
  const carouselItems = useMemo(
    () =>
      PROJECTS.map((project) => {
        const heroBlock = project.blocks.find((block) => block.type === 'image');
        return {
          slug: project.slug,
          title: project.title,
          subtitle: project.subtitle,
          image: heroBlock ? heroBlock.src : null,
        };
      }).filter((project) => project.image),
    []
  );

  if (!carouselItems.length) {
    return null;
  }

  return (
    <section className="section portfolio latest-work-grid">
      <div className="wrapper">
        <div className="portfolio-heading-row">
          <h2 className="portfolio-heading">{heading}</h2>
        </div>
      </div>
      <div className="wrapper grid-display">
        <div className="row">
          {carouselItems.slice(0, 2).map((item) => (
            <div className="portfolio-grid-item" key={item.slug}>
              <Link to={`/projects/${item.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="portfolio-grid-media">
                  <img src={item.image} alt={item.title} />
                </div>
                <div className="portfolio-grid-caption">
                  <div className="portfolio-grid-title">{item.title}</div>
                  <div className="portfolio-grid-subtitle">{item.subtitle}</div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <div className="row">
          {carouselItems.slice(2, 5).map((item) => (
            <div className="portfolio-grid-item" key={item.slug}>
              <Link to={`/projects/${item.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="portfolio-grid-media">
                  <img src={item.image} alt={item.title} />
                </div>
                <div className="portfolio-grid-caption">
                  <div className="portfolio-grid-title">{item.title}</div>
                  <div className="portfolio-grid-subtitle">{item.subtitle}</div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <div className="row full-height">
          {carouselItems.slice(5, 6).map((item) => (
            <div className="portfolio-grid-item" key={item.slug}>
              <Link to={`/projects/${item.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="portfolio-grid-media">
                  <img src={item.image} alt={item.title} />
                </div>
                <div className="portfolio-grid-caption">
                  <div className="portfolio-grid-title">{item.title}</div>
                  <div className="portfolio-grid-subtitle">{item.subtitle}</div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestWorkGrid;
